import React from 'react'
import Icon from '../../../../../components/icon'
import { If } from '../../../../../components/if/if'
import Table from '../../../../../components/table'
import ITable from '../../../../../interfaces/table'

import {
  Container,
  Header,
  Wrapper,
  InputWrapper,
  Input,
  NewProductButton,
  CategoriesWrapper,
  CreateCategoryButton,
  Tag,
} from './styles'

type IProps = any & {
  tableData: ITable;
}

const ProductList = ({
  goToEditor,
  tableData,
  handleOpenCategoryForm,
  setCurrentFilterItem,
  currentFilterItem,
  searchTerm,
  setSearchTerm,
  categories = [{ name: 'Todos', uuid: '0' }],
}: IProps) => (
  <Container>
    <Header>
      <InputWrapper>
        <Icon name="search" />
        <Input
          placeholder="Buscar"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </InputWrapper>

      <NewProductButton onClick={goToEditor}>
        <Icon name="plus" />
        Novo produto
      </NewProductButton>
    </Header>

    <CategoriesWrapper>
      {
        categories.map((category: any, index: number) => (
          <Tag
            key={category.id}
            isSelected={category?.id === currentFilterItem?.id}
            onClick={() => setCurrentFilterItem(category)}
          >
            {category.name}
            <If condition={index > 0}>
              <button
                type="button"
                onClick={() => handleOpenCategoryForm(category)}
              >
                <Icon name="edit" />
              </button>
            </If>
          </Tag>
        ))
      }
      <CreateCategoryButton onClick={handleOpenCategoryForm}>
        + Add categoria
      </CreateCategoryButton>
    </CategoriesWrapper>

    <Wrapper>
      <Table data={tableData} />
    </Wrapper>
  </Container>
)

export default ProductList
